import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import {
  ContentTooltiptLearningContinuumInfo,
  useStyles
} from '../../Dashboard/Assessment/Classes/MarkingClasses/ContentTooltip/ContentTooltip';
import PaperLG from './PaperLG';

const TableLearningGrowth = ({ lcs = [], loading, currentCurriculum, classUlInfo, size, maxLevel, isLevel = true }) => {
  const classes = useStyles();

  let levelsId = [];
  lcs?.forEach((lc) => {
    const lvls = lc.granularSteps?.filter((step) => step.definition).map((step) => step.levelId);
    levelsId = [...levelsId, ...lvls];
  });

  levelsId = [...new Set(levelsId)];
  const levelsRender = currentCurriculum?.levels
    ?.filter((item) => (loading ? true : levelsId.includes(item._id)))
    .sort((a, b) => a.position - b.position);

  const minMarking = currentCurriculum?.marking.find((m) => m.minValue);
  const maxMarking = currentCurriculum?.marking.find((m) => m.maxValue);
  const left = classUlInfo ? 115 : 50;
  const lcElement = currentCurriculum?.lcElements?.children?.sort((a, b) => b.position - a.position)[0];

  return (
    <TableContainer>
      <Table style={{ width: 'auto' }}>
        <TableHead>
          <TableRow className='sticky top-0px z-12'>
            {classUlInfo ? (
              <TableCell style={{ padding: '1px' }} className='sticky left-0px z-12'>
                <Paper
                  style={{ height: size }}
                  className=' z-10 max-w-100px min-w-100px px-2 py-2 bg-muted-foreground text-muted text-center h-10 flex flex-col items-center justify-center rounded capitalize font-bold'
                >
                  <Typography variant='inherit' children='Version / Class' className=' text-xs' />
                  <Typography
                    variant='inherit'
                    children='Unit of Learning'
                    size='small'
                    className='font-bold text-sm'
                  />
                </Paper>
              </TableCell>
            ) : (
              <TableCell style={{ padding: '1px' }} className='sticky left-0px z-12'>
                <Paper
                  style={{ height: size }}
                  className=' z-10 max-w-35px min-w-35px text-xs px-2 py-2  bg-muted-foreground text-muted text-center h-10 flex items-center justify-center rounded capitalize font-bold'
                >
                  Version
                </Paper>
              </TableCell>
            )}
            <TableCell style={{ padding: '1px', left }} className='sticky left-0px z-12'>
              <Paper
                style={{ height: size }}
                className=' z-10 max-w-200px min-w-200px px-2 py-2 bg-muted-foreground text-muted text-center h-10 flex items-center justify-center rounded capitalize font-bold'
              >
                {lcElement?.name || 'Learning continuum'}
              </Paper>
            </TableCell>
            {levelsRender?.map((item) => {
              let color = minMarking?.primaryColor || 'inherit';
              let backgroundColor = minMarking?.secondaryColor || 'inherit';
              if (maxLevel.levelPosition === item.position) {
                color = maxLevel?.primaryColor || 'inherit';
                backgroundColor = maxLevel?.secondaryColor || 'inherit';
              } else if (item.position < maxLevel.levelPosition) {
                color = maxMarking?.primaryColor || 'inherit';
                backgroundColor = maxMarking?.secondaryColor || 'inherit';
              } else if (item.position > maxLevel.levelPosition) {
                color = minMarking?.primaryColor || 'inherit';
                backgroundColor = minMarking?.secondaryColor || 'inherit';
              }
              return (
                <TableCell key={`level-header-${item._id}`} style={{ padding: '1px' }}>
                  <Paper
                    className='size-10 px-2 py-2 bg-muted-foreground text-muted text-center h-10 flex items-center justify-center rounded capitalize font-bold text-lg'
                    style={{
                      width: size,
                      height: size,
                      backgroundColor,
                      color
                    }}
                  >
                    {item.code}
                  </Paper>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            Array.from({ length: 12 }).map((_, index) => (
              <TableRow key={`ul-skeleton-${index}`}>
                {classUlInfo ? (
                  <TableCell style={{ padding: '1px' }} className='sticky left-0px z-12'>
                    <Skeleton
                      style={{ height: size }}
                      variant='rounded'
                      className=' z-10 max-w-100px min-w-100px px-2 py-2 '
                    ></Skeleton>
                  </TableCell>
                ) : (
                  <TableCell style={{ padding: '1px' }} className='sticky left-0px z-12'>
                    <Skeleton
                      style={{ height: size }}
                      variant='rounded'
                      className=' z-10 max-w-35px min-w-35px px-2 py-2 '
                    ></Skeleton>
                  </TableCell>
                )}
                <TableCell style={{ padding: '1px' }}>
                  <Skeleton variant='rounded' className='w-full h-10  py-2' style={{ height: size }} />
                </TableCell>
                {levelsRender?.map((item) => (
                  <TableCell key={`level-skeleton-${item._id}-index-${index}`} style={{ padding: '1px' }}>
                    <Skeleton
                      variant='rounded'
                      className='w-full h-10 px-2 py-2'
                      style={{ width: size, height: size }}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : lcs.length > 0 ? (
            lcs.map((lc, index) => {
              const granularSteps = lc.granularSteps?.filter((step) => isLevel ? step.isLevel && levelsId.includes(step.levelId) : levelsId.includes(step.levelId))
                .map((step) => ({
                  ...step,
                  level: currentCurriculum.levels.find((lvl) => lvl._id === step.levelId)
                })).sort((a, b) => a.level.position - b.level.position);
              return (
                <TableRow key={`lc-${lc._id}-index-${index}`}>
                  {classUlInfo ? (
                    <TableCell style={{ padding: '1px' }} className='sticky left-0px z-12'>
                      <Paper
                        style={{ height: size }}
                        className=' z-10 max-w-100px min-w-100px px-2 py-2 bg-muted-foreground text-muted text-center h-10 flex flex-col items-center justify-center rounded capitalize font-bold'
                      >
                        <Typography variant='inherit' className=' text-xs'>
                          v{lc.version || '1'} / class
                        </Typography>
                        <Typography
                          variant='inherit'
                          children='Unit of Learning'
                          size='small'
                          className='font-bold text-sm'
                        />
                      </Paper>
                    </TableCell>
                  ) : (
                    <TableCell style={{ padding: '1px' }} className='sticky left-0px z-12'>
                      <Paper
                        style={{ height: size }}
                        className=' z-10 max-w-35px min-w-35px px-2 py-2 text-xs bg-muted-foreground text-muted text-center h-10 flex items-center justify-center rounded capitalize font-bold'
                      >
                        v{lc.version || '1'}
                      </Paper>
                    </TableCell>
                  )}
                  <TableCell style={{ padding: '1px', left }} className='sticky left-0px z-10'>
                    <Paper
                      className=' px-2 py-2 bg-muted-foreground text-muted text-center rounded gap-2 max-w-200px min-w-200px'
                      style={{ height: size }}
                    >
                      <Tooltip
                        arrow
                        placement='top'
                        id={`guttman-chart-table-lc-lc-${lc._id}`}
                        title={
                          <ContentTooltiptLearningContinuumInfo
                            lc={lc}
                            currentCurriculum={currentCurriculum}
                          />
                        }
                        classes={{ tooltip: classes.customWidthGuttmanChart }}
                      >
                        <Typography
                          children={lc?.lcElements?.[lcElement?._id] || 'None'}
                          style={{
                            height: size,
                            overflow: 'hidden',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical'
                          }}
                          className=' text-sm flex items-center justify-start'
                        />
                        {/* {lc._id} */}
                      </Tooltip>
                    </Paper>
                  </TableCell>
                  {granularSteps?.map((item) => (
                    <TableCell key={`level-header-${item.levelId}-gs-${item.id}`} style={{ padding: '1px' }}>
                      <PaperLG
                        lc={lc}
                        gs={item}
                        level={item.level}
                        size={size}
                        minMarking={minMarking}
                        maxMarking={maxMarking}
                        levels={currentCurriculum.levels}
                        levelsRender={levelsRender}
                        currentCurriculum={currentCurriculum}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell style={{ padding: '1px' }}>
                <Typography
                  component='div'
                  className='flex items-center justify-start px-4 h-14 bg-background text-muted-foreground bg-muted rounded text-sm font-bold'
                >
                  No units of learning found.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableLearningGrowth;
